export default class TelesoftSyncManager {
  constructor() {
    this.csrfToken = $('meta[name="csrf-token"]').attr('content');
  }

  // Single entity operations (for BackofficeEntitiesForm)
  checkSingleEntity(modal) {
    const checkUrl = modal.data('check-url');
    const entityName = modal.data('entity-name');
    
    return $.ajax({
      url: checkUrl,
      method: 'POST',
      dataType: 'json',
      headers: {
        'X-CSRF-Token': this.csrfToken
      },
      data: JSON.stringify({
        customer_name: entityName
      }),
      contentType: 'application/json'
    });
  }

  syncSingleEntity(modal) {
    const syncUrl = modal.data('sync-url');
    
    return $.ajax({
      url: syncUrl,
      method: 'POST',
      dataType: 'json',
      headers: {
        'X-CSRF-Token': this.csrfToken
      },
      contentType: 'application/json'
    });
  }

  updateSingleEntity(modal) {
    const updateUrl = modal.data('update-url');
    
    return $.ajax({
      url: updateUrl,
      method: 'POST',
      dataType: 'json',
      headers: {
        'X-CSRF-Token': this.csrfToken
      },
      contentType: 'application/json'
    });
  }

  // Single product operations (for BackofficeProductsForm)
  checkSingleProduct(modal) {
    const checkUrl = modal.data('check-url');
    
    return $.ajax({
      url: checkUrl,
      method: 'POST',
      dataType: 'json',
      headers: {
        'X-CSRF-Token': this.csrfToken
      },
      contentType: 'application/json'
    });
  }

  syncSingleProduct(modal) {
    const syncUrl = modal.data('sync-url');
    
    return $.ajax({
      url: syncUrl,
      method: 'POST',
      dataType: 'json',
      headers: {
        'X-CSRF-Token': this.csrfToken
      },
      contentType: 'application/json'
    });
  }

  updateSingleProduct(modal) {
    const updateUrl = modal.data('update-url');
    
    return $.ajax({
      url: updateUrl,
      method: 'POST',
      dataType: 'json',
      headers: {
        'X-CSRF-Token': this.csrfToken
      },
      contentType: 'application/json'
    });
  }

  // Bulk operations (for BackofficeEntitiesIndex)
  checkMultipleEntities(entities, bulkCheckUrl) {
    return $.ajax({
      url: bulkCheckUrl,
      method: 'POST',
      dataType: 'json',
      headers: {
        'X-CSRF-Token': this.csrfToken
      },
      data: JSON.stringify({
        entities: entities.map(entity => ({
          id: entity.id,
          name: entity.name
        }))
      }),
      contentType: 'application/json'
    });
  }

  syncMultipleEntities(entityIds, bulkSyncUrl) {
    return $.ajax({
      url: bulkSyncUrl,
      method: 'POST',
      dataType: 'json',
      headers: {
        'X-CSRF-Token': this.csrfToken
      },
      data: JSON.stringify({
        entity_ids: entityIds
      }),
      contentType: 'application/json'
    });
  }

  // Bulk operations for products (for ProductIndex)
  checkMultipleProducts(products, bulkCheckUrl) {
    return $.ajax({
      url: bulkCheckUrl,
      method: 'POST',
      dataType: 'json',
      headers: {
        'X-CSRF-Token': this.csrfToken
      },
      data: JSON.stringify({
        products: products.map(product => ({
          id: product.id,
          name: product.name,
          code: product.code
        }))
      }),
      contentType: 'application/json'
    });
  }

  syncMultipleProducts(productIds, bulkSyncUrl) {
    return $.ajax({
      url: bulkSyncUrl,
      method: 'POST',
      dataType: 'json',
      headers: {
        'X-CSRF-Token': this.csrfToken
      },
      data: JSON.stringify({
        product_ids: productIds
      }),
      contentType: 'application/json'
    });
  }

  // UI Helper methods
  showLoading(selector) {
    $(selector).show();
  }

  hideLoading(selector) {
    $(selector).hide();
  }

  showResult(selector, message = '') {
    $(selector).show();
    if (message) {
      $(selector).find('.message').text(message);
    }
  }

  resetModalState(selectors) {
    Object.keys(selectors).forEach(key => {
      if (selectors[key].show) {
        $(selectors[key].show).show();
      }
      if (selectors[key].hide) {
        selectors[key].hide.forEach(sel => $(sel).hide());
      }
    });
  }
}